import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
`;

export const Title = styled.h1`
    color: #333;
    leading-trim: both;
    text-edge: cap;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const ContainerForm = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 100%;
    @media (max-width: 992px) {
        width: 100%;
    }
`;